class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
     
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const collectionEl = gridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');
    }
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        InitCustomFunctions();
        syncSliderFromURL();
      })
      .catch(() => {
        const gc = document.getElementById('ProductGridContainer');
        if (gc) { const col = gc.querySelector('.collection'); if (col) col.classList.remove('loading'); }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    InitCustomFunctions();
    syncSliderFromURL();
  }

  static renderProductGridContainer(html) {
    const target = document.getElementById('ProductGridContainer');
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (target && source) {
      document.documentElement.style.overflowAnchor = 'none';

      // Reset StickySidebar BEFORE the swap so page height reflects real content,
      // not the stale inflated min-height. The resize handler only sets
      // stickySidebar position:static — it skips resetting min-height — so we
      // must do the full n() reset manually here.
      const sidebarEl = document.querySelector('.sidebar-sticky');
      const stickySidebarEl = sidebarEl && sidebarEl.querySelector('.StickySidebar');
      if (sidebarEl) sidebarEl.style.minHeight = '1px';
      if (stickySidebarEl) { stickySidebarEl.style.position = 'static'; stickySidebarEl.style.width = ''; }

      target.innerHTML = source.innerHTML;

      // scrollHeight now reflects actual new content height (sidebar no longer inflating it).
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (window.scrollY > maxScroll) {
        const gridTop = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo(0, Math.max(0, gridTop));
      }

      // Let StickySidebar recalibrate from the corrected scroll position.
      window.dispatchEvent(new Event('resize'));

      requestAnimationFrame(() => {
        document.documentElement.style.overflowAnchor = '';
      });
    }
  }

  static renderProductCount(html) {
    const sourceCount = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container && sourceCount) {
      container.innerHTML = sourceCount.innerHTML;
      container.classList.remove('loading');
    }
    if (containerDesktop && sourceCount) {
      containerDesktop.innerHTML = sourceCount.innerHTML;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
    
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }  
    
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    InitCustomFunctions();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
 

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    InitCustomFunctions();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });

    // FIX: Function ko delay ke sath call karein
    setTimeout(() => {
      if (typeof InitCustomFunctions === 'function') {
        InitCustomFunctions();
      } else {
        console.warn('InitCustomFunctions abhi tak load nahi hua hai.');
      }
    }, 100); 
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);   
  }
}



function initPriceSlider() {
    var slider = document.getElementById("price-slider");
    var priceMinInput = document.getElementById("Filter-Price-GTE");
    var priceMaxInput = document.getElementById("Filter-Price-LTE");

    if (!priceMinInput || !priceMaxInput || !slider) return;

    function getUpdatedPriceRange() {
        let minPrice = parseFloat(priceMinInput.getAttribute("min")) || 0;
        let maxPrice = parseFloat(priceMaxInput.getAttribute("max")) || 1000;
        let startMin = parseFloat(priceMinInput.value) || minPrice;
        let startMax = parseFloat(priceMaxInput.value) || maxPrice;
        return { minPrice, maxPrice, startMin, startMax };
    }

    var { minPrice, maxPrice, startMin, startMax } = getUpdatedPriceRange();

    // Check if slider already exists, update instead of recreating
    if (slider.noUiSlider) {
        slider.noUiSlider.updateOptions({
            range: { min: minPrice, max: maxPrice },
            start: [startMin, startMax],
        });
        return;
    }

    // Initialize noUiSlider
    noUiSlider.create(slider, {
        start: [startMin, startMax],
        connect: true,
        range: { min: minPrice, max: maxPrice },
        tooltips: [true, true],
        format: {
            to: (value) => parseFloat(value).toFixed(2),
            from: (value) => Number(value),
        },
    });

    // Update input fields when slider moves
    slider.noUiSlider.on("update", function (values) {
        priceMinInput.value = values[0];
        priceMaxInput.value = values[1];
    });

    // Update slider when input fields change
    function updateSliderFromInputs() {
    var slider = document.getElementById("price-slider");
    var priceMinInput = document.getElementById("Filter-Price-GTE");
    var priceMaxInput = document.getElementById("Filter-Price-LTE");

    if (!slider.noUiSlider) return;

    let minValue = parseFloat(priceMinInput.value) || parseFloat(priceMinInput.getAttribute("min")) || 0;
    let maxValue = parseFloat(priceMaxInput.value) || parseFloat(priceMaxInput.getAttribute("max")) || 1000;

    console.log("Updating slider from inputs:", minValue, maxValue);

    // Ensure valid range
    if (minValue < parseFloat(priceMinInput.getAttribute("min"))) {
        minValue = parseFloat(priceMinInput.getAttribute("min"));
    }
    if (maxValue > parseFloat(priceMaxInput.getAttribute("max"))) {
        maxValue = parseFloat(priceMaxInput.getAttribute("max"));
    }
    if (minValue > maxValue) {
        minValue = maxValue;
    }

    // Update the slider with new values
    slider.noUiSlider.set([minValue, maxValue]);
}

// **Add event listeners to update slider when input values change**
document.addEventListener("input", function (event) {
    if (event.target.id === "Filter-Price-GTE" || event.target.id === "Filter-Price-LTE") {
        updateSliderFromInputs();
    }
});

    priceMinInput.addEventListener("change", updateSliderFromInputs);
    priceMaxInput.addEventListener("change", updateSliderFromInputs);

    // Trigger filtering when slider values change
    slider.noUiSlider.on("change", function(values) {
    const params = new URLSearchParams(window.location.search);

    params.set("filter.v.price.gte", values[0]);
    params.set("filter.v.price.lte", values[1]);

    const newUrl = window.location.pathname + "?" + params.toString();

    // IMPORTANT: directly call Shopify filter system
    FacetFiltersForm.renderPage(params.toString());
    });
}

// **Trigger Shopify AJAX Filtering**
function triggerFiltering(minPrice, maxPrice) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("filter.v.price.gte", minPrice);
    currentUrl.searchParams.set("filter.v.price.lte", maxPrice);

    fetchProducts(currentUrl.toString());
}

function syncSliderFromURL() {
    var slider = document.getElementById("price-slider");
    var priceMinInput = document.getElementById("Filter-Price-GTE");
    var priceMaxInput = document.getElementById("Filter-Price-LTE");

    if (!slider || !slider.noUiSlider) return;

    const params = new URLSearchParams(window.location.search);

    const min = parseFloat(params.get("filter.v.price.gte"));
    const max = parseFloat(params.get("filter.v.price.lte"));

    if (isNaN(min) || isNaN(max)) return;

    // update inputs
    priceMinInput.value = min;
    priceMaxInput.value = max;

    // update slider
    slider.noUiSlider.set([min, max]);
}

document.addEventListener("DOMContentLoaded", function () {
    initPriceSlider();

    setTimeout(() => {
        syncSliderFromURL();
    }, 300);
});

// **Fetch Updated Products and Refresh Slider**
function fetchProducts(url) {
    fetch(url)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newProductGrid = doc.querySelector("#product-grid");

            const productGrid = document.querySelector("#product-grid");
            if (productGrid && newProductGrid) {
                productGrid.innerHTML = newProductGrid.innerHTML;
            }

            // Update slider after products reload
            updatePriceSliderAfterFiltering(doc);
        })
        .catch(error => {
            console.error("Error fetching filtered products:", error);
        });
}

// **Ensure Slider Updates Properly After Filtering**
function updatePriceSliderAfterFiltering(doc) {
    setTimeout(() => {
        var slider = document.getElementById("price-slider");
        var priceMinInput = document.getElementById("Filter-Price-GTE");
        var priceMaxInput = document.getElementById("Filter-Price-LTE");

        if (!priceMinInput || !priceMaxInput || !slider) return;

        // Get updated min/max values from the new document
        let newMinInput = doc.querySelector("#Filter-Price-GTE");
        let newMaxInput = doc.querySelector("#Filter-Price-LTE");

        if (!newMinInput || !newMaxInput) {
            console.error("Filtered price inputs not found in the document");
            return;
        }

        let newMinPrice = parseFloat(newMinInput.value) || 0;
        let newMaxPrice = parseFloat(newMaxInput.value) || 1000;
        let newMinRange = parseFloat(newMinInput.getAttribute("min")) || 0;
        let newMaxRange = parseFloat(newMaxInput.getAttribute("max")) || 1000;

        console.log("Updating Slider:", newMinPrice, "-", newMaxPrice);

        // Update input fields with new values
        priceMinInput.value = newMinPrice;
        priceMaxInput.value = newMaxPrice;

        // If slider exists, just update values instead of destroying it
        if (slider.noUiSlider) {
            slider.noUiSlider.updateOptions({
                start: [newMinPrice, newMaxPrice],
                range: { min: newMinRange, max: newMaxRange },
            });
        }
    }, 500);
}

// **Ensure Slider Updates After Shopify AJAX Filtering**
$(document).on("shopify:section:load shopify:section:reorder", function () {
    setTimeout(initPriceSlider, 200);
});

// **Run on First Load**
document.addEventListener("DOMContentLoaded", initPriceSlider);

customElements.define('facet-remove', FacetRemove);


(function() {
    function getVariantCount(label, activeFilters) {
        if (!window.collectionVariants) return 0;
        let count = 0;
        const cleanLabel = label.trim().toLowerCase();
        
        window.collectionVariants.forEach(v => {
            // 1. Availability Check (Custom logic)
            const isAvailable = v.available;
            const matchesAvailability = (cleanLabel === 'in stock') ? isAvailable : 
                                        (cleanLabel === 'out of stock') ? !isAvailable : true;

            // 2. Tags/Options Check
            const tagMatch = v.tags.toLowerCase().includes(cleanLabel);
            const optionMatch = v.options.some(opt => opt && opt.toLowerCase() === cleanLabel);

            // Sirf wahi count karo jo label se match kare
            if (tagMatch || optionMatch || (cleanLabel.includes('stock') && matchesAvailability)) {
                count++;
            }
        });
        return count;
    }


    

    // 1. Filtered Variants ki list nikalne ka function
    function getFilteredVariants() {
        if (!window.collectionVariants) return [];

        // Active filters le lo
        const activeFilters = Array.from(document.querySelectorAll('.facets__form input:checked, .mobile-facets__checkbox:checked'))
                                   .map(input => input.value.toLowerCase());

        return window.collectionVariants.filter(v => {
            const variantData = (v.tags + " " + v.options.join(" ")).toLowerCase();
            
            return activeFilters.every(filter => {
                if (filter === 'in stock') return v.available === true;
                if (filter === 'out of stock') return v.available === false;
                return variantData.includes(filter);
            });
        });
    }

    function getPriceRange() {
        return {
            min: parseFloat(document.querySelector('[name="filter.v.price.gte"]')?.value || 0),
            max: parseFloat(document.querySelector('[name="filter.v.price.lte"]')?.value || Infinity)
        };
    }



    function fixCounts() {
        if (!window.collectionVariants) return;

        // 1. All Active Filters (Checkbox values)
        const activeCheckboxes = document.querySelectorAll('.facets__form input:checked, .mobile-facets__checkbox:checked');
        const activeFilters = Array.from(activeCheckboxes).map(input => ({
            name: input.name,
            value: input.value.toLowerCase()
        }));

        // 2. Filtered List Logic
        // Group filters by filter name
        const groupedFilters = {};

        activeFilters.forEach(filter => {
            if (!groupedFilters[filter.name]) {
                groupedFilters[filter.name] = [];
            }
            groupedFilters[filter.name].push(filter.value);
        });

         // 3. PRICE RANGE (IMPORTANT FIX)
        const { min, max } = getPriceRange();

        const filteredList = window.collectionVariants.filter(v => {

            const variantData = (v.tags + " " + v.options.join(" ")).toLowerCase();

            // 🔥 PRICE FILTER FIRST
            const price = parseFloat(v.price || 0);
            if (price < min || price > max) return false;

            return Object.keys(groupedFilters).every(group => {

                const values = groupedFilters[group];

                // Availability
                if (group.includes("availability")) {

                    if (values.includes("in_stock") || values.includes("true")) {
                        if (!v.available) return false;
                    }

                    if (values.includes("out_of_stock") || values.includes("false")) {
                        if (v.available) return false;
                    }

                    return true;
                }

                // SAME GROUP => OR
                return values.some(value => variantData.includes(value));

            });

        });

        // 3. Update Header Counter
        const headerCount = document.getElementById('ProductCount');
        if (headerCount) {
            headerCount.innerText = filteredList.length + " Variants Available";
        }

        // 4. Update Sidebar Counters
        const counters = document.querySelectorAll(".dynamic-variant-count");
        const baseList = filteredList; // already includes price + active filters

        counters.forEach(counter => {
            const label = counter.dataset.filterLabel.trim().toLowerCase();
            if (!label) return;

            let count = 0;

            if (label === 'in stock') {
                count = baseList.filter(v => v.available === true).length;
            } 
            else if (label === 'out of stock') {
                count = baseList.filter(v => v.available === false).length;
            } 
            else {
                count = baseList.filter(v => {
                    const vData = (v.tags + " " + v.options.join(" ")).toLowerCase();
                    return vData.includes(label);
                }).length;
            }

            counter.innerText = "(" + count + ")";
        });

        applyStockDOMFilter();
    }

    // Observer: Shopify filter load hone ka wait karo
    const observer = new MutationObserver(() => {
        setTimeout(() => {
            fixCounts();
            applyStockDOMFilter();
        }, 500);
    });

    const targetNode = document.querySelector('.facets__form') || document.body;
    observer.observe(targetNode, { childList: true, subtree: true });

    // Initial run
    fixCounts();




    function applyStockDOMFilter() {

      const items = document.querySelectorAll('.variant-item, .product-item');

      // Availability checkboxes (IMPORTANT: use name, not label text)
      const inStockInput = document.querySelector(
          'input[name="filter.v.availability"][value="1"]:checked'
      );

      const outStockInput = document.querySelector(
          'input[name="filter.v.availability"][value="0"]:checked'
      );

      const inStockActive = !!inStockInput;
      const outStockActive = !!outStockInput;

      items.forEach(item => {

          const available = item.dataset.available === "true";

          // CASE 1: only In Stock selected
          if (inStockActive && !outStockActive) {
              item.style.display = available ? "" : "none";
          }

          // CASE 2: only Out of Stock selected
          else if (outStockActive && !inStockActive) {
              item.style.display = !available ? "" : "none";
          }

          // CASE 3: both or none
          else {
              item.style.display = "";
          }
      });
  }
})();



